<template>
    <div name="basic-pc" class="pc-barocare-new">
        <BarocareHeader />
        <Home />
        <ServiceIntro />
        <CompanyIntro />
        <ServiceUse />
        <Inquiry />
        <BarocareFooter />
    </div>
</template>

<script>
import BarocareHeader from '@/components/pc_barocare_new/BarocareHeader';
import Home from '@/components/pc_barocare_new/Home';
import ServiceIntro from '@/components/pc_barocare_new/ServiceIntro';
import CompanyIntro from '@/components/pc_barocare_new/CompanyIntro';
import ServiceUse from '@/components/pc_barocare_new/ServiceUse';
import Inquiry from '@/components/pc_barocare_new/Inquiry';
import BarocareFooter from '@/components/pc_barocare_new/BarocareFooter';

export default {
    name: 'basicPc',
    components: {
        BarocareHeader,
        Home,
        ServiceIntro,
        CompanyIntro,
        ServiceUse,
        Inquiry,
        BarocareFooter,
    },
    mounted: function(){
        $('html').animate({
            scrollTop: 0
        }, 300)
    }
}
</script>

<style lang="scss">
@import "../styles/PcBarocareNew.scss";
</style>


// WEBPACK FOOTER //
// src/page/PcBarocareNew.vue